class VariantUrlChange {
    constructor() {

        window.onload = () => {
            this.bindInit();
        }
    }
    bindInit() {
      this.colourValueChangeInUrl();
      this.galleryThumbnail();
    }

    colourValueChangeInUrl() {
        const urlChanged = document.querySelectorAll('.js-get-colour-value');
        if (urlChanged) {
            urlChanged.forEach(getURlChanged => {
                getURlChanged.addEventListener("click", function () {
                    const urlChangedValue = getURlChanged.getAttribute('data-value')
                    history.replaceState({ urlChangedValue }, '', `${window.location.pathname}${urlChangedValue && '?'.concat(urlChangedValue)}`);

                });
            });
        }
    }

    galleryThumbnail() {
      const galleryThumbanail = document.querySelectorAll('.js-product-photo-thumb');
      if (galleryThumbanail) {
        galleryThumbanail.forEach(getGalleryThumbanail => {
          getGalleryThumbanail.addEventListener("click", function () {
            const getGalleryAttributeValue = getGalleryThumbanail.getAttribute('data-value');

            const variantColour = document.querySelectorAll('.js-select-option-colour');
            if (variantColour) {
                variantColour.forEach(getVariantColour => {
                  const variantChangedValue = getVariantColour.getAttribute('data-value')
                  if (getGalleryAttributeValue == variantChangedValue) {
                    getVariantColour.click();
                  }
                });
            }

            });
          });
      }
  }
}

new VariantUrlChange();
